import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Company } from '../../types/api/Company';
import { TextField } from '@mui/material';
import { Close } from '@mui/icons-material';
import Spinner from '../../globalComponents/spinner';
import SpinnerSize from '../../enums/spinnerSize';
import { useApi } from '../../hooks/useApi';
import { toastError, toastSuccess } from '../../Toaster/Toast.tsx';

const EditCompany:React.FC<{ company: Company; onClose: ()=> void; gridRef: React.MutableRefObject<any> }> = ({ company, onClose, gridRef }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const api = useApi();

    const [isSaving, setIsSaving] = useState(false);

    const save = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();      

        setIsSaving(true);
    
        const data = new FormData(e.target as HTMLFormElement);

        const formData: object = {};

        data.forEach((value, key) => {
            formData[key] = value;
        }); 

        const result = await api.company.updateDetails(company._id, formData)

        if (!result.errored) {
            await gridRef.current?.onRefresh()

            setIsSaving(false);
            onClose()
            toastSuccess({
                title: 'Company Updated',
                description: `You have successfully updated company: ${company.name}`,
            })
        } else {
            setIsSaving(false);
            // ErrorToast(`Error updating company: ${result.error}`)
            toastError({
                title: 'Error',
                description: result.error?.message ?? undefined,
            });
        }
    }

    return <div className="fixed left-0 top-0 w-[100vw] h-[100vh] bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
        <div className='w-[95%] sm:w-[500px] lg:w-[600px] max-h-[90vh] overflow-y-auto bg-white rounded-md p-5'>
            <div className='w-full my-3 flex justify-between text-primary'>
                <h1 className='font-bold text-2xl'>Edit Company</h1>

                <button onClick={onClose}>
                    <Close fontSize='large' className='font-bold hover:text-red-500' />
                </button>
            </div>

            <form className='w-full flex flex-col items-center' onSubmit={save}>
                <div className='w-full grid grid-cols-2 gap-4 my-3'>
                    <TextField 
                        label="Name"
                        name="name"
                        type="text"
                        defaultValue={company?.name}
                        fullWidth
                        margin="normal"
                        variant="outlined"
                    />
                    <TextField
                        label="Owner"
                        name="owner"
                        defaultValue={company?.owner}
                        fullWidth
                        margin="normal"
                        variant="outlined"
                    />
                </div>

                <button className='btn-success m-auto flex gap-2 justify-center items-center' type="submit" disabled={isSaving}>
                    Save {isSaving && <Spinner size={SpinnerSize.SMALL} />}
                </button>
            </form>
        </div>
    </div>
}

export default EditCompany